import React from "react";
import { getMapImageUrl } from "../../constants/mapMeta";
import { formatMapName, resolveMatchMapIdFromSelectionKey } from "../../constants/maps";
import MapThumbCard from "../common/MapThumbCard";

export default function MapCard({
    name,
    mapsSelected = [],
    onMapClicked,
    disabled = false,
}) {
    const selectionKey = name.toLowerCase().replace(/\s+/g, "_");
    const mapId = resolveMatchMapIdFromSelectionKey(selectionKey);
    const imageUrl = getMapImageUrl(mapId);
    const displayName = formatMapName(name);
    const checked = mapsSelected.includes(selectionKey);

    return (
        <MapThumbCard
            imageUrl={imageUrl}
            label={displayName}
            checked={checked}
            disabled={disabled}
            onClick={() => onMapClicked(selectionKey)}
        />
    );
}
